import script from "./IndexLaporan.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexLaporan.vue?vue&type=script&setup=true&lang=js"

import "./IndexLaporan.vue?vue&type=style&index=0&id=1d6437b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6437b3"]])

export default __exports__